import { render, staticRenderFns } from "./popup-wu-liao-choose-more.vue?vue&type=template&id=67724a1d&scoped=true"
import script from "./popup-wu-liao-choose-more.vue?vue&type=script&lang=js"
export * from "./popup-wu-liao-choose-more.vue?vue&type=script&lang=js"
import style0 from "./popup-wu-liao-choose-more.vue?vue&type=style&index=0&id=67724a1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67724a1d",
  null
  
)

export default component.exports